import { Component, OnInit, Inject } from "@angular/core";
import { Router } from "@angular/router";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { PrincipalinventoryService } from "../../../services/principalinventory.service";
import { SecurazeService } from "../../../services/securaze.service";
import { TicketsService } from "../../../services/tickets.service";
import { Countries } from "../../../models/countries";
import { Inventory } from "../../../models/inventory";
import { Methods } from "../../../shared/methods";
import swal from 'sweetalert2';

@Component({
  selector: "app-bulk-virtual-container-inventory",
  templateUrl: "./bulk-virtual-container-inventory.component.html",
  styleUrls: ["./bulk-virtual-container-inventory.component.css"],
  providers: [SecurazeService, PrincipalinventoryService, TicketsService]
})
export class BulkVirtualContainerInventoryComponent implements OnInit {
  public loading = false;
  public saving = false;
  public mtds: Methods = new Methods();  
  public virtualContainerName = '';
  public containerSelected = 0;
  public savingcontainer = false;

  public identity;
  public token;

  constructor(
    private _securazeService: SecurazeService,
    private _service: PrincipalinventoryService,
    private _ticketsService: TicketsService,
    private _router: Router,
    public dialogRef: MatDialogRef<BulkVirtualContainerInventoryComponent>,
    @Inject(MAT_DIALOG_DATA) public id: number
  ) {
    this.identity = JSON.parse(localStorage.getItem("identity"));
    console.log(this.identity);
    this.token = JSON.parse(localStorage.getItem("token"));
  }

  ngOnInit() {    
    this.getVirtualContainers();
  }

  onCancelClick(): void {
    this.dialogRef.close(false);
  }

  public loadingContainers = false;
  public virtualContainers = [];

  getVirtualContainers() {
    
    this.loadingContainers = true;
    this.virtualContainers = [];

    this._securazeService.getContainers(this.token).subscribe(
      response => {

        response.data.forEach(
            function (element) {
              this.virtualContainers.push({
                  id: element.id,
                  name: element.nameVirtualContainer
                });
            }.bind(this)
          );

        this.virtualContainers.sort((a,b) => {
          const n1 = a.name.toLowerCase();
          const n2 = b.name.toLowerCase();

          if (n1 < n2) { return -1; }
          if (n1 > n2) { return 1; }
          return 0;
        });

        /*if(param === 1)
          this.showC = true;*/
        this.loadingContainers = false;

      }, error => {
        this.loadingContainers = false;
      }

    );
  }

  addVirtualContainer() {

    this.savingcontainer = true;
    this.loadingContainers = false;

    let json ={
      enableAsAVirtualContainer: 1,
      nameVirtualContainer: this.virtualContainerName
    }

    this._ticketsService.createVirtual(json).toPromise().then(
      async response =>{

        if (response.code === 200) {

          this.showSwal('success', 'Container Saved!', 'Container has been saved successfully');
          //this.mtds.notifySuccess('Container has been saved successfully');

          await this.getVirtualContainers();

        } else if (response.code === 400) {
          localStorage.clear();
          this._router.navigate(['/pages/lock']);
        } else {
          //this.mtds.notifyError(response.msg, response.code);
          this.showSwal('error', 'ERROR!', response.msg);
        }

        this.savingcontainer = false;
        this.virtualContainerName = '';

      }, error => {
        this.savingcontainer = false;
        //this.mtds.notifyError(error.statusText, error.status);
        this.showSwal('error', 'ERROR!', error.status);
      }
    );
  }


  saveVirtualContainer() {
    this.dialogRef.close(this.containerSelected);
  }

  selectVirtualContainer(e) {
    this.containerSelected = e.id;
  }

  //public containerSelected = '';

  showSwal(type, title = '', message = '') {
    if (type === 'success') {
        swal.fire({
           
            title: title,
            text: message,
            buttonsStyling: false,
         customClass:{
    confirmButton: 'btn btn-success'
            },

        });

    } else if (type === 'error') {
        swal.fire({
         
          title: title,
          text: message,
          buttonsStyling: false,
         customClass:{
    confirmButton: 'btn btn-success'
            },

        });
    }
  }

}
